export default __webpack_public_path__ + "static/media/play_pressed.13590fe1.svg";